import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licence: '=',
        uibModalInstance: '=',
        preconditionCourses: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'licence.Edit licence name' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-plain" ng-if="vm.licence.hasUpdatedPreconditions">
                <p>{{ 'licence.Implementing licence preconditions is active. Editing general data is not allowed.' | translate }} </p>
            </div>
            <form class="form" ng-submit="vm.save()">
                <manage-settings-licences-form
                    form="vm.form"
                    chosen-preconditions="vm.chosenPreconditions"
                    licence="vm.licence"
                    show-precondition-toggle="true"
                />
                <button type="submit" class="hidden" >{{ 'licence.Save licence' | translate }}</button>
            </form>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (FormFactory, toastr, $translate) {
        this.form = FormFactory.createFromResource(this.licence, { expand: 'licencePeriods,licenceDrlsWithValue' });
        this.toastr = toastr;
        this.$translate = $translate;
        this.form.model.licencePreconditions = null;
    }

    $onInit () {
        this.chosenPreconditions = null;
        if (this.preconditionCourses) {
            this.chosenPreconditions = this.preconditionCourses.map((course) => ({ id: course.id, name: course.activeI18n.name }));
        }
    }

    beforeSave () {
        if (this.chosenPreconditions) {
            this.form.model.licencePreconditions = this.chosenPreconditions.map((precondition) => ({ licenceId: this.licence.id, courseId: precondition.id }));
        }

        if (!this.form.model.hasPrecondition) {
            this.form.model.licencePreconditions = [];
        }
    }

    save () {
        this.beforeSave();
        this.form.save().then((licence) => {
            this.toastr.success(this.$translate.instant('licence.Licence general data successfully saved.'));
            this.uibModalInstance.close(licence);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/licences/edit/index.js